import "./css/SectionPlatform.css";

import { ImChrome } from "react-icons/im";
import { ImAndroid } from "react-icons/im";
import { FaAppStoreIos } from "react-icons/fa";
import { Link } from "react-router-dom";

function SectionPlatform() {
  return (
    <section className="section-platform">
      <div className="platform-container landing-container">
        <h2 className="section-heading">Road to Multi-Platforms</h2>
        <p>
          PhysioTrack is currently available as a web application, accessible
          from any device.
        </p>
        <div className="platforms">
          <Link to="/login">
            <ImChrome className="icon" style={{ fontSize: "2.9rem" }} />
            <span className="platform">Web</span>
            <span className="action">Get Started</span>
          </Link>
          <Link href="" className="disabled" tabIndex={-1} disabled>
            <ImAndroid className="icon" />
            <span className="platform">Android</span>
            <span className="action">Download</span>
          </Link>
          <Link href="" className="disabled" tabIndex={-1} disabled>
            <FaAppStoreIos className="icon" />
            <span className="platform">iOS</span>
            <span className="action">Download</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SectionPlatform;
